import { render, staticRenderFns } from "./luckCardList.vue?vue&type=template&id=afbd5806&scoped=true&"
import script from "./luckCardList.vue?vue&type=script&lang=ts&"
export * from "./luckCardList.vue?vue&type=script&lang=ts&"
import style0 from "./luckCardList.vue?vue&type=style&index=0&id=afbd5806&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afbd5806",
  null
  
)

export default component.exports